import React, { useState, useEffect } from "react";
import axios from "../plugins/axios";
import {
    TextField,
    Autocomplete,
} from "@mui/material";

const apiUrl = process.env.REACT_APP_WORKNEST_TOOLS_API_URL;

const AccountAutoComplete = ({ handleAccountChange, label }) => {    

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);

    const [value, setValue] = useState({});

    useEffect(() => {
        let active = true;

        if (!input || input.length < 3) {
            setOptions([]);
            return undefined;
        }

        (async () => {
            setLoading(true);
            const clients = (await axios.get(`${apiUrl}/getclients/` + encodeURIComponent(input))).data;
            if (active) {
                setOptions(clients);
            }
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [open, input]);

    const onChange = (e, v) => {
        handleAccountChange(v);
        setValue(v);
    };

    const getOptionLabel = (option) => {
        return option.text || "";
    }
    
    return (
        <Autocomplete
            freeSolo            
            inputValue={input}
            open={open}
            value={value}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={getOptionLabel}
            // Two options can share the same `text` (e.g. duplicate Salesforce accounts);
            // use the unique `value` (Salesforce ID) as the React key.
            renderOption={(props, option) => {
                const { key, ...rest } = props;
                return <li key={option.value} {...rest}>{option.text}</li>;
            }}
            onChange={onChange}
            options={options}
            loading={loading}
            onInputChange={(e, val) => setInput(val)}
            renderInput={(params) => {
                return <TextField {...params} fullWidth size="small" name="noAutoFill" label={label} />;
            }}
        />
    );
}

export default AccountAutoComplete;
